import AccountPurchaserService from './AccountPurchaserService';
import AllAccountPurchaserService from './AllAccountPurchaserService';

export const accountPurchaserService = new AccountPurchaserService();
export const allAccountPurchaserService = new AllAccountPurchaserService();

